<template>
  <div v-if="content" class="osv-activity-list max-w-5xl">
    <custom-title :content="title" class="mb-8 mt-0" />
    <div class="">
      <div class="grid grid-cols-1 gap-6 grid-osv">
        <div>
          <osv-card class="mb-10" :step="1" title="Je selectionne une activité">
            <ul class="grid-cols-1 gap-6 grid md:grid-cols-2 lg:grid-cols-3">
              <li class="" v-for="(activity, i) in content.activities">
                <div
                  @click="selectActivity(activity)"
                  class="block bg-white rounded-lg shadow-md overflow-hidden cursor-pointer h-full"
                >
                  <div
                    class="bg-osv-card md:h-96 h-64 relative bg-cover bg-no-repeat bg-center"
                    :style="bgStyle(activity.img)"
                  >
                    <!--<svg
                      class="absolute bottom-0"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 1440 320"
                    >
                      <path
                        fill="#ffffff"
                        fill-opacity="1"
                        d="M0,128L48,138.7C96,149,192,171,288,160C384,149,480,107,576,85.3C672,64,768,64,864,85.3C960,107,1056,149,1152,165.3C1248,181,1344,171,1392,165.3L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
                      ></path>
                    </svg>-->
                  </div>

                  <div class="p-5 md:-mt-10 sm:-mt-12 -mt-4  relative bg-white z-10">
                    <h3 class="text-center text-primary font-bold mb-6">{{ activity.title }}</h3>

                    <vue-markdown class="markdown-card text-gray-500 text-xs leading-snug"
                      >{{ activity.text }}
                    </vue-markdown>
                    <div class="text-center mt-5">
                      <button
                        class="bg-primary text-white text-center py-3 px-4 rounded-md shadow-lg hover:bg-primary-dark transition-colors"
                        @click="selectActivity(activity)"
                      >
                        Réserver
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </osv-card>
        </div>

        <div class="" ref="calendar">
          <div v-if="selectedActivity">
            <osv-card :step="2" title="Je réserve mon activité" id="card-calendar">
              <div class="max-w-2xl mx-auto">
                <osv-activity-calendar
                  widget-options="showDuration=false;showRemainingPlace=false;timeSlotFormat=[Arrivée à ]HH[h]mm"
                  :activity-ids="selectedActivity.activity_id || '*'"
                />
              </div>
            </osv-card>
          </div>
          <div v-else-if="loading" class="mx-auto text-center mt-10">
            <fai class="icon text-6xl text-primary" icon="spinner" spin />
          </div>
          <div v-else class="text-center font-bold mx-10"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { content } from "tailwindcss/lib/plugins";
import VueMarkdown from "vue-markdown";
export default {
  props: {
    content: null
  },
  components: {
    VueMarkdown
  },
  data() {
    return {
      selectedActivity: null,
      loading: false
    };
  },
  computed: {
    title() {
      return {
        align: "center",
        level: "h2",
        title: this.content.text
      };
    }
  },
  methods: {
    selectActivity(activity) {
      if (
        activity.buyLink &&
        activity.buyLink.trim() != "" &&
        activity.buyLink.trim().indexOf("http") === 0
      ) {
        window.open(activity.buyLink, "_blank");
      } else {
        this.selectedActivity = null;
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.selectedActivity = activity;
          if (document.querySelector("#card-calendar")) {
            document.querySelector("#card-calendar").scrollIntoView({ behavior: "smooth" });
          }
          //this.$refs.calendar.$el.scrollIntoView({ behavior: "smooth" });
        }, 350);
      }
    },
    bgStyle(img) {
      return {
        backgroundImage: `url(${img.filename})`
      };
    }
  }
};
</script>

<style lang="scss">
.grid-osv {
  // max-height:800px;
}

@media screen and (max-width: 1024px) {
  .grid-osv {
    // max-height: none;
  }
}

.osv-activity-list {
  max-width: 95%;
  width: 95%;
  margin: auto;
  margin-bottom: 50px;

  .markdown-card {
    p {
      margin-bottom: 10px;
    }
  }

  .bg-osv-card {
    //height: 500px;
    // clip-path: polygon(100% 0%, 0% 0%, 0% 65%, 1% 64.95%, 2% 64.8%, 3% 64.6%, 4% 64.3%, 5% 63.9%, 6% 63.45%, 7% 62.9%, 8% 62.25%, 9% 61.55%, 10% 60.8%, 11% 59.95%, 12% 59.05%, 13% 58.1%, 14% 57.1%, 15% 56.05%, 16% 55%, 17% 53.9%, 18% 52.8%, 19% 51.65%, 20% 50.5%, 21% 49.35%, 22% 48.2%, 23% 47.05%, 24% 45.9%, 25% 44.8%, 26% 43.75%, 27% 42.75%, 28% 41.75%, 29% 40.8%, 30% 39.9%, 31% 39.1%, 32% 38.35%, 33% 37.65%, 34% 37.05%, 35% 36.5%, 36% 36.05%, 37% 35.65%, 38% 35.35%, 39% 35.15%, 40% 35.05%, 41% 35%, 42% 35.05%, 43% 35.2%, 44% 35.45%, 45% 35.75%, 46% 36.15%, 47% 36.65%, 48% 37.2%, 49% 37.85%, 50% 38.55%, 51% 39.35%, 52% 40.2%, 53% 41.1%, 54% 42.05%, 55% 43.05%, 56% 44.1%, 57% 45.15%, 58% 46.3%, 59% 47.4%, 60% 48.55%, 61% 49.7%, 62% 50.85%, 63% 52%, 64% 53.15%, 65% 54.25%, 66% 55.35%, 67% 56.4%, 68% 57.45%, 69% 58.4%, 70% 59.35%, 71% 60.2%, 72% 61.05%, 73% 61.8%, 74% 62.45%, 75% 63.05%, 76% 63.6%, 77% 64.05%, 78% 64.4%, 79% 64.7%, 80% 64.85%, 81% 65%, 82% 65%, 83% 64.9%, 84% 64.75%, 85% 64.5%, 86% 64.2%, 87% 63.75%, 88% 63.25%, 89% 62.7%, 90% 62.05%, 91% 61.3%, 92% 60.5%, 93% 59.65%, 94% 58.75%, 95% 57.8%, 96% 56.8%, 97% 55.75%, 98% 54.65%, 99% 53.55%, 100% 52.4%);
  }
}
</style>
